<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="dialogFormVisible"
      @open="open"
      width="484px"
      center
      class="set-invoice-form"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="dialogClose"
    >
      <p>应通道要求，申请手续费发票需要上传商户协议，烦请上传商户协议。</p>
      <p>1.下载 <span @click="downloadXls">《协议模板》</span></p>
      <p>2.打开下载的模板，填写信息，盖章后拍照上传</p>
      <div>
        <el-upload
          accept=".jpg, .png, .jpeg"
          class="head-portrait"
          :class="{ hide: hideUpload || fileList.length }"
          :file-list="fileList"
          :limit="imgLimit"
          :multiple="false"
          :action="uploadURl"
          list-type="picture-card"
          :on-change="onChange"
          :before-upload="beforeUpload"
          :on-preview="handlePictureCardPreview"
          :on-success="handleAvatarSuccess"
          :on-error="handleAvatarError"
          :on-remove="handleRemove"
        >
          <img
            v-if="fileList.length && fileList[0].url"
            width="100%"
            :src="fileList[0].url"
            alt
          />
          <i class="el-icon-plus" v-else></i>
          <div class="el-upload__tip" slot="tip">
            上传要求：不大于1M
          </div>
        </el-upload>
        <el-dialog
          :visible.sync="headPortraitVisible"
          class="picture-preview"
          append-to-body
        >
          <img width="100%" :src="imgUrl" alt />
        </el-dialog>
      </div>

      <span slot="footer">
        <el-button type="primary" v-preventReClick @click="submitForm"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <iframe
      v-if="actionUrl"
      @load="iframeLoad"
      ref="iframeExportRef"
      frameborder="0"
      name="export-target"
      style="display:none"
    ></iframe>
    <form
      style="display:none"
      method="post"
      :action="actionUrl"
      ref="exportForm"
      target="export-target"
    ></form>
  </div>
</template>
<script>
import { urlData } from "@api/api";
import { messageTips, fileImg } from "@api/utils";
export default {
  name: "UploadProtocol",
  props: {
    visible: Boolean,
    title: String
  },
  computed: {
    dialogFormVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  data() {
    return {
      fileList: [],
      headPortraitVisible: false,
      imgUrl: "",
      hideUpload: false,
      uploadURl: urlData("juhe/img/uploadImage.do"),
      imgLimit: 1,
      actionUrl: urlData("/juhe/serviceChargeInvoice/downloadFile.do")
    };
  },
  methods: {
    open() {
      this.handleRemove();
    },
    dialogClose() {
      this.handleRemove();
    },
    downloadXls() {
      this.$nextTick(() => {
        this.$refs.exportForm.submit();
      });
    },
    beforeUpload(file) {
      // 文件上传前
      if (file.size > 1048576) {
        messageTips(this, "error", "本地上传图片不能超过1M");
        return false;
      }
      let pos = file.name.split(".");
      if (!(pos.length && fileImg(file) > 0)) {
        messageTips(this, "error", "请传入JPG、JPEG、PNG格式的图片");
        return false;
      }
    },
    onChange(file, fileList) {
      this.hideUpload = fileList.length >= this.imgLimit;
    },
    handlePictureCardPreview() {
      this.headPortraitVisible = true;
    },
    handleRemove() {
      this.imgUrl = "";
      this.fileList = [];
      this.hideUpload = false;
    },
    handleAvatarError(res, file) {
      this.$message.error(JSON.parse(res.message).message);
    },
    handleAvatarSuccess(res, file) {
      if (String(res.code) !== "200") {
        this.$message.error(res.msg || res.message);
        this.handleRemove();
      } else {
        this.imgUrl = file.response.data.showImagePath;
        this.fileList = [
          { name: file.name, url: file.response.data.showImagePath }
        ];
      }
    },
    iframeLoad() {
      this.$nextTick(() => {
        if (this.$refs.iframeExportRef.contentWindow.document.body.innerText) {
          try {
            const obj = JSON.parse(
              this.$refs.iframeExportRef.contentWindow.document.body.innerText
            );
            console.log(obj);
            this.$message.warning(obj.message);
          } catch (e) {
            console.log(e);
            this.$message.warning("导出失败，请联系管理员！");
          }
        }
      });
    },
    submitForm() {
      if (!this.imgUrl) {
        this.$message.warning("请先上传图片");
        return;
      }
      this.api
        .post("/juhe/serviceChargeInvoice/addMerchantAgreement.do", {
          posReceiptAgreementPic: this.imgUrl
        })
        .then(({ data, code, message }) => {
          if (code === 200 && data) {
            this.$emit("submit");
          } else {
            this.$message.error(message);
          }
        });
    }
  }
};
</script>
<style lang="scss">
.set-invoice-form {
  .el-form-item {
    margin-bottom: 16px;
  }
  .el-dialog__header {
    text-align: left;
    padding: 17px;
    > span {
      font-size: 14px;
      color: #333333;
      line-height: 20px;
    }
  }
  .el-list-enter-active,
  .el-list-leave-active {
    -webkit-transition: none;
    transition: none;
    // -webkit-transition: opacity 0.2s;
    // transition: opacity 0.2s;
  }
  .el-dialog__body {
    padding: 25px;
    font-size: 14px;
    color: #333333;
    line-height: 25px;
    p {
      text-align: left;
      span {
        color: #1989fa;
        cursor: pointer;
      }
    }
  }
  .el-dialog__footer {
    text-align: center;
    .el-button--primary {
      width: 100px;
      height: 36px;
      padding: 0;
    }
  }
}
.hide {
  .el-upload--picture-card {
    display: none;
  }
}
.head-portrait {
  margin-top: 20px;
  text-align: center;
  .el-upload-list--picture-card .el-upload-list__item,
  .el-upload--picture-card {
    width: 130px;
    height: 130px;
  }
  .el-upload__tip {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 14px;
    margin-top: 15px;
  }
}
</style>
